import { inject, Injectable } from '@angular/core';
import { catchError, EMPTY } from 'rxjs';
import { BackgroundAction } from '../../../../core/classes/BackgroundAction';
import { CartStatuses } from '../enums/CartStatuses';
import { CartStore } from '../stores/CartStore';
import { CartService } from './CartService';

@Injectable({
  providedIn: 'root'
})
export class SeatNoteRefreshService {

  private static readonly REFRESH_INTERVAL_SECONDS = 60;

  private readonly _cartService = inject(CartService);
  private readonly _cartStore = inject(CartStore);

  private readonly _action = new BackgroundAction(
    SeatNoteRefreshService.REFRESH_INTERVAL_SECONDS,
    () => this.refresh()
  );

  private _initialized = false;

  public initialize(): void {
    if (this._initialized) {
      return;
    }

    this._initialized = true;
    this._action.start();
  }

  private refresh(): void {
    const cart = this._cartStore.cart();
    const status = cart?.status;

    if (
      !cart ||
      this._cartStore.cartItemsTickets().length === 0 ||
      status === CartStatuses.CheckedOut ||
      status === CartStatuses.CheckoutFailed
    ) {
      return;
    }

    this._cartService.refreshSeatNotes()
      .pipe(catchError(() => EMPTY))
      .subscribe();
  }
}
